import React from 'react';
import { useTranslation } from 'react-i18next';
import CatalogManager from './CatalogManager';
import { Truck } from '../../types/catalogs';

const TrucksPage: React.FC = () => {
  const { t } = useTranslation();
  const columns = [
    { key: 'matricula', label: t('plate') },
    { key: 'conductor', label: t('driver') },
    { key: 'tipo', label: t('typeLabel') },
  ];

  const formFields = [
    { name: 'matricula', label: t('plate'), type: 'text' as const, required: true },
    { name: 'conductor', label: t('driver'), type: 'text' as const },
    {
      name: 'tipo',
      label: t('typeLabel'),
      type: 'select' as const,
      required: true,
      options: [
        { value: 'FRESADO', label: t('typeMilling') },
        { value: 'OBRA', label: t('typeSite') },
        { value: 'MEZCLA', label: t('typeMix') },
      ],
    },
    { name: 'activo', label: t('active'), type: 'checkbox' as const },
  ];

  const createEmptyItem = () => ({
    matricula: '',
    conductor: '',
    tipo: '',
    activo: true,
  });

  const validateItem = (item: any) => {
    if (!item.matricula?.trim()) return t('requiredPlate');
    if (!item.tipo) return t('requiredType');
    return null;
  };

  return (
    <CatalogManager<Truck>
      title={t('catalogTrucks')}
      apiEndpoint="trucks"
      columns={columns}
      formFields={formFields}
      getItemId={(item) => item.id}
      getItemAttributes={(item) => item.attributes}
      createEmptyItem={createEmptyItem}
      validateItem={validateItem}
    />
  );
};

export default TrucksPage;
